import { ref, computed } from "vue";
import { getAllTopics } from "@/config/topics";
import { profileNavLinks } from "@/config/siteConfig";

export function useNavigation() {
  // 获取所有分类
  const allTopics = getAllTopics();

  // 将分类转换为下拉菜单项
  const articleDropdownItems = computed(() => {
    return allTopics.map((topic) => ({
      label: `${topic.icon} ${topic.name}`,
      path: `/topic/${topic.id}`,
    }));
  });

  // 从配置中获取"关于我"链接
  const aboutMeLink = profileNavLinks.find((link) => link.label === "关于我");

  const navItems = ref([
    {
      label: "Home",
      path: "/",
      variant: "primary",
      color: "#8a2be2",
    },
    {
      label: "Articles",
      path: "/articles",
      variant: "danger",
      dropdown: articleDropdownItems.value,
    },
    {
      label: "About Me",
      path: aboutMeLink ? aboutMeLink.href : "/",
      variant: "secondary",
      color: "#ff69b4",
    },
  ]);

  return {
    navItems,
  };
}
